// extracted by mini-css-extract-plugin
export var container = "_3x-0";
export var containerTopRight = "_3x-1";